module.exports = __webpack_public_path__ + "/img/remove-button.0438aa182a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/remove-button.svg
// module id = 1395
// module chunks = 0